import { Async } from "@lexriver/async"
import { TypeEvent, TypeEventResult } from "@lexriver/type-event"
import { BasketInLocalStorage } from "./Basket/BasketInLocalStorage"
import { BasketOnServer } from "./Basket/BasketOnServer"
import { IBasket } from "./Basket/IBasket"
import { FavoritesInLocalStorage } from "./Favorites/FavoritesInLocalStorage"
import { FavoritesOnServer } from "./Favorites/FavoritesOnServer"
import { IFavorites } from "./Favorites/IFavorites"
import { GlobalUser } from "./GlobalUser"

export module GlobalFavorites{

    //let isInitialized = false
    export const onFavoritesUpdateEvent = new TypeEvent<()=>TypeEventResult>()
    export const onFavoritesEmptyOrNotEvent = new TypeEvent<(isEmpty:boolean)=>TypeEventResult>()

    export let anonymousFavorites = new FavoritesInLocalStorage()

    function initAnonymousFavorites(){
        anonymousFavorites.onChangeEvent.subscribe(async () => {
            //console.log('@', 'BasketInLocalStorage on change')
            //DomeEventDispatcher.triggerEvent(EnumDomeEventDispatcherEvents.BasketUpdated)
            await onFavoritesUpdateEvent.triggerAsync()
        })
        anonymousFavorites.onFavoritesEmptyOrNotEvent.subscribe(async (isEmpty:boolean) => {
            //console.log('@', 'BasketInLocalStorage on empty/not')
                                            
            //DomeEventDispatcher.triggerEvent(EnumDomeEventDispatcherEvents.BasketEmptyOrNot, {isEmpty})
            await onFavoritesEmptyOrNotEvent.triggerAsync(isEmpty)
        })
    }

    export let loggedInUserFavorites = new FavoritesOnServer()

    function initUserFavorites(){
        loggedInUserFavorites.onChangeEvent.subscribe(async () => {
            //DomeEventDispatcher.triggerEvent(EnumDomeEventDispatcherEvents.BasketUpdated)
            await onFavoritesUpdateEvent.triggerAsync()
        })
        loggedInUserFavorites.onFavoritesEmptyOrNotEvent.subscribe(async (isEmpty:boolean) => {
            //DomeEventDispatcher.triggerEvent(EnumDomeEventDispatcherEvents.BasketEmptyOrNot, {isEmpty})
            await onFavoritesEmptyOrNotEvent.triggerAsync(isEmpty)
        })
    }

    export async function getCurrentFavoritesAsync():Promise<IFavorites>{
        if(await GlobalUser.checkIfLoggedInAsync()) {
            await Async.waitForFunctionToReturnTrueAsync(() => loggedInUserFavorites.isInitialized(), 500, 100000)
            return loggedInUserFavorites
        }
        return anonymousFavorites
    }

    function reactOnLoginLogout(){
        GlobalUser.eventUserLoggedIn.subscribe(async () => {
            //loggedInUserBasket = new BasketOnServer()
            await onFavoritesUpdateEvent.triggerAsync()
        })
        GlobalUser.eventUserLoggedOut.subscribe(async () => {
            //anonymousBasket = new BasketInLocalStorage()
            await onFavoritesUpdateEvent.triggerAsync()
        })
        GlobalUser.loggedInUserO.eventOnChange.subscribe(async () => {
            await onFavoritesUpdateEvent.triggerAsync()
        })
    }


    function initAsync(){
        initAnonymousFavorites()
        initUserFavorites()
        reactOnLoginLogout()
    }

    initAsync()


}